import actions from './actions';

const {
  PROJECT_ADD_BEGIN,
  PROJECT_ADD_SUCCESS,
  PROJECT_ADD_ERR,

  PROJECT_READ_BEGIN,
  PROJECT_READ_SUCCESS,
  PROJECT_READ_ERR,

  PROJECT_UPDATE_BEGIN,
  PROJECT_UPDATE_SUCCESS,
  PROJECT_UPDATE_ERR,

  PROJECT_DELETE_BEGIN,
PROJECT_DELETE_SUCCESS,
PROJECT_DELETE_ERR,
} = actions;

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const addinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const deleteinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const updateStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const PROJECTReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case PROJECT_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case PROJECT_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case PROJECT_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const PROJECTAddReducer = (state = addinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case PROJECT_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case PROJECT_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case PROJECT_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

   
    default:
      return state;
  }
};

const PROJECTUpdateReducer = (state = updateStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    
    case PROJECT_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case PROJECT_UPDATE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case PROJECT_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const PROJECTDeleteReducer = (state = deleteinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    
    case PROJECT_DELETE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case PROJECT_DELETE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case PROJECT_DELETE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { PROJECTReducer, PROJECTUpdateReducer, PROJECTAddReducer, PROJECTDeleteReducer };
